import { defaultNetwork, IS_TESTNET } from './walletConnectionConfig'
import SECH_TESTNET_ABI from './ABI/SECH_TESTNET_ABI.json'
import SECH_MAINNET_ABI from './ABI/SECH_MAINNET_ABI.json'
import UNISWAP_ROUTER_ABI from './ABI/UNISWAP_ROUTER_ABI.json'

export const FUNDS_RECEIVER_WALLET_ADDRESS = import.meta.env
  .VITE_FUNDS_RECEIVER_WALLET_ADDRESS
export const SERVICE_WALLET_ADDRESS =
  '0x379DD2550F47dEAC455f296B3C8E1b132Fba96ea'

export const TEST_TOKEN_CONTRACT_ADDRESS =
  '0x9a6E7F563C5059B34fE8138139a0D44D9c2F3736'
export const MAINNET_TOKEN_CONTRACT_ADDRESS =
  '0x87B40e0cc30755Ecb93Ac1EB07a3636C9fA18149'

export const TOKEN_CONTRACT_ADDRESS = IS_TESTNET
  ? TEST_TOKEN_CONTRACT_ADDRESS
  : MAINNET_TOKEN_CONTRACT_ADDRESS
export const SECH_ABI = IS_TESTNET ? SECH_TESTNET_ABI : SECH_MAINNET_ABI
export const SECH_TOKEN_DECIMAL = 18

export const USDC_ARBITRUM_ADDRESS =
  '0xaf88d065e77c8cC2239327C5EDb3A432268e5831'
// WETH on Sepolia testnet network for the testnet SWAP
export const WETH_ADDRESS = '0xfff9976782d46cc05630d1f6ebab18b2324d6b14'
export const SELL_TOKEN_ABBR = IS_TESTNET ? 'ETH' : 'USDC'

export const SWAP_TOKEN_DECIMALS = IS_TESTNET ? 18 : 6
export const ROUTER_ADDRESS = IS_TESTNET
  ? '0xeE567Fe1712Faf6149d80dA1E6934E354124CfE3' // Sepolia Uniswap v2 router contract
  : '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24' // Arbitrum Uniswap v2 router contract
export const ROUTER_ABI = UNISWAP_ROUTER_ABI
export const PAIR_CONTRACT_ADDRESS = IS_TESTNET
  ? '0xbb4955df7ac9e7a67922c8a9ec3bca96fbd30f76'
  : '0x19be57e2ac8d703558265397b0e287572a92792d'

// Fee percentage for conversion fee to token
export const CASH_CONVERSION_FEE = 2

// Signatures info
export const SIGNATURE_DOMAIN = {
  name: 'SECH',
  version: '1.0.0',
  chainId: defaultNetwork.id as number,
  verifyingContract: TOKEN_CONTRACT_ADDRESS as `0x${string}`
}

const BASIC_TYPES = [
  { name: 'from', type: 'address' },
  { name: 'to', type: 'address' },
  { name: 'amount', type: 'uint256' },
  { name: 'nonce', type: 'uint256' }
]

// Mainnet have additional deadline field
const MAINNET_TRANSFER_TYPE = [
  ...BASIC_TYPES,
  { name: 'deadline', type: 'uint256' }
]

const TRANSFER_TYPE = IS_TESTNET ? BASIC_TYPES : MAINNET_TRANSFER_TYPE
// Define the types for EIP-712 signature
export const SIGNATURE_TYPES = {
  TransferRequest: TRANSFER_TYPE
}
